<template>
    <div class="chat-quick-reply-picker">
        <CButton
            color="secondary"
            variant="outline"
            class="chat-quick-reply-picker__btn mr-2"
            :disabled="disabled || loading"
            @click="open"
        >
            Шаблоны
        </CButton>

        <CModal
            title="Шаблоны сообщений"
            :show.sync="visible"
            :footer="false"
            size="lg"
        >
            <template>
                <div slot="body-wrapper" class="modal-body">
                    <div v-if="loading" class="text-muted">Загрузка...</div>
                    <div v-else-if="!items.length" class="text-muted">
                        Шаблонов пока нет. Добавьте их в справочнике «Шаблоны сообщений в чатах».
                    </div>
                    <div v-else class="chat-quick-reply-picker__list">
                        <button
                            v-for="item in items"
                            :key="item.id"
                            type="button"
                            class="chat-quick-reply-picker__item"
                            @click="selectItem(item)"
                        >
                            <div class="chat-quick-reply-picker__title">{{ item.title }}</div>
                            <div class="chat-quick-reply-picker__preview">{{ item.body }}</div>
                        </button>
                    </div>
                </div>
                <div slot="footer">
                    <CButton
                        color="light"
                        class="ml-3"
                        @click="visible = false"
                    >
                        Закрыть
                    </CButton>
                </div>
            </template>
        </CModal>
    </div>
</template>

<script>
    import Vue from 'vue';
    import {
        applyQuickReplyPlaceholders,
        buildQuickReplyContext,
        getChatQuickReplies
    } from '@/utils/chatQuickReply';

    export default {
        name: 'ChatQuickReplyPicker',
        props: {
            disabled: {
                type: Boolean,
                default: false
            },
            customer: {
                type: Object,
                default: () => ({})
            },
            chat: {
                type: Object,
                default: () => ({})
            },
            order: {
                type: Object,
                default: () => ({})
            }
        },
        data() {
            return {
                visible: false,
                loading: false,
                items: []
            };
        },
        methods: {
            async open() {
                if (this.disabled) {
                    return;
                }
                this.visible = true;
                await this.ensureLoaded();
            },
            async ensureLoaded() {
                this.loading = true;
                try {
                    this.items = await getChatQuickReplies(Vue.axios);
                } catch (e) {
                    this.$root.$emit('showError', 'Не удалось загрузить шаблоны');
                } finally {
                    this.loading = false;
                }
            },
            selectItem(item) {
                const context = buildQuickReplyContext({
                    customer: this.customer,
                    chat: this.chat,
                    order: this.order
                });
                const text = applyQuickReplyPlaceholders(item.body, context);
                this.$emit('select', text);
                this.visible = false;
            }
        }
    };
</script>

<style scoped>
.chat-quick-reply-picker {
    display: inline-flex;
}

.chat-quick-reply-picker__list {
    display: flex;
    flex-direction: column;
    gap: 8px;
    max-height: 420px;
    overflow: auto;
}

.chat-quick-reply-picker__item {
    display: block;
    width: 100%;
    text-align: left;
    border: 1px solid #d8dbe0;
    border-radius: 6px;
    background: #fff;
    padding: 10px 12px;
    cursor: pointer;
}

.chat-quick-reply-picker__item:hover {
    border-color: #321fdb;
    background: #f8f9fa;
}

.chat-quick-reply-picker__title {
    font-weight: 600;
    margin-bottom: 4px;
}

.chat-quick-reply-picker__preview {
    color: #768192;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
